import { BASE_URL } from '../../../../config/environmentConfig';
import { eligibilityActionTypes } from '../eligibility-action-types';
import * as React from 'react';
import { IEligibilityAction } from '../eligibility-interfaces';
import { IBlockBodyProps } from '../../../components/orders/BlockListModal';
import { GET, POST } from '../../store-helper';

export const fetchBlockList = async (dispatch: React.Dispatch<IEligibilityAction>, orderId: string): Promise<void> => {
	try {
		const data = await GET({
			pathname: `${BASE_URL.ELIGIBILITY}/RiskManagement/order/${orderId}/get-fingerprints`,
		});
		dispatch({ type: eligibilityActionTypes.FETCH_FINGERPRINTS_LIST, payload: data?.fingerprints ?? [] });
	} catch (e) {
		console.log('fetchBlockList error', e);
		dispatch({ type: eligibilityActionTypes.FETCH_FINGERPRINTS_LIST, payload: [] });
	}
};

export const setBlockByFingerPrints = async (
	dispatch: React.Dispatch<IEligibilityAction>,
	orderId: string,
	body: IBlockBodyProps
): Promise<void> => {
	try {
		dispatch({ type: eligibilityActionTypes.START_SET_BLOCK_LOADING });

		await POST({
			pathname: `${BASE_URL.ELIGIBILITY}/RiskManagement/order/${orderId}/block-by-fingerprints`,
			body,
		});

		dispatch({ type: eligibilityActionTypes.END_SET_BLOCK_LOADING });
	} catch (e) {
		console.log(e);
		dispatch({ type: eligibilityActionTypes.END_SET_BLOCK_LOADING });
	}
};
